












import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import emitter from "@/lib/emitter";
import { getMediaDuration } from "@/lib/time";
import { EVENTS } from "@/const";
import {
  GlobalAudioPlayerActions,
  GlobalAudioPlayerActionSetTime,
  GlobalAudioPlayerActionToggle,
  GlobalAudioPlayerFileState,
} from "../types";

export default defineComponent({
  name: "GlobalAudioPlayerController",
  props: {
    src: { type: String, required: true },
    active: { type: Boolean, required: true },
    file: { type: Object as () => FileData | ContentFile, required: true },
    state: {
      type: Object as PropType<Omit<GlobalAudioPlayerFileState, "uuid">>,
      default: () => ({
        isPlay: false,
        currentTime: 0,
        formattedRemainingTime: "",
      }),
    },
  },
  setup(props, { emit }) {
    const duration = ref(+(props.file.metadata?.duration ?? 0) / 1000);

    const formattedRemainingTime = computed(() =>
      props.active ? props.state.formattedRemainingTime : getMediaDuration(duration.value * 1000)
    );

    const loadDuration = () => {
      const audio = new Audio(props.src);
      audio.addEventListener(
        "loadedmetadata",
        () => {
          duration.value = audio.duration;
        },
        { once: true }
      );
      audio.load();
    };

    if (!duration.value) loadDuration();

    const toggleAudio = (): void => {
      if (props.active) {
        emitter.emit<GlobalAudioPlayerActionToggle>(EVENTS.AUDIO_PLAYER_ACTION, {
          name: GlobalAudioPlayerActions.TOGGLE_AUDIO,
          uuid: props.file.uuid,
        });
      } else {
        emit("init");
      }
    };

    const setTime = (sec: number) => {
      emitter.emit<GlobalAudioPlayerActionSetTime>(EVENTS.AUDIO_PLAYER_ACTION, {
        name: GlobalAudioPlayerActions.SET_TIME,
        uuid: props.file.uuid,
        time: sec,
      });
    };

    return {
      duration,
      setTime,
      toggleAudio,
      formattedRemainingTime,
    };
  },
});
